<template>
    <!-- contents -->
    <div>
        <!-- //Basic Info head -->
        <div class="sub_tit mt25">{{ $t('FIELD.GLOBAL.BASIC.INFO') }}</div>
        <!-- detail_Basic Info -->
        <table class="create_table">
            <colgroup>
                <col width="13.5%" />
                <col width="*" />
                <col width="13.5%" />
                <col width="*" />
            </colgroup>
            <tbody>
                <tr>
                    <th>{{ $t('FIELD.USER.ID') }}</th>
                    <td>
                        <span class="clearable">
                            <input type="text" class="text_input w100" v-model="loginId" disabled="" />
                        </span>
                    </td>
                    <th>{{ $t('FIELD.USER.NAME') }}</th>
                    <td>
                        <span class="clearable">
                            <input type="text" class="text_input w100" v-model="loginName" disabled="" />
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('FIELD.USER.EMAIL') }}</th>
                    <td>
                        <span class="clearable">
                            <input type="text" class="text_input w100" v-model="email" disabled="" />
                        </span>
                    </td>
<!--                     <th>{{ $t('FIELD.GLOBAL.LEVEL') }}</th> -->
                    <th>Support Level</th>
		            <td data-input-type="select">
		                        <select class="slt_white w100" v-model="deptLevel" @change="changeLevel()" disabled>
		                            <option value="" selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
		                            <option v-for="code in levelTypes" :key="code.code" :value="code.code">{{
		                                code.codeName
		                            }}</option>
		                        </select>
		            </td>
                </tr>
               <!--  <tr>
                    <th>{{ $t('FIELD.GLOBAL.PHONE.NUMBER') }}</th>
                    <td>
                        <span class="clearable">
                            <input type="text" class="text_input w100" v-model="phoneNo" disabled="" />
                        </span>
                    </td>
                    <th>{{ $t('FIELD.USER.MOBILE.NO') }}</th>
                    <td>
                        <span class="clearable">
                            <input type="text" class="text_input w100" v-model="mobileNo" disabled="" />
                        </span>
                    </td>
                </tr> -->
                <tr>
<!--                     <th>{{ $t('FIELD.GLOBAL.SAMSUNG.EMPLOYEE') }}123</th> -->
<!--                     <td> -->
<!--                         <div class="fL mt5"> -->
<!--                             <label class="radiobox-wrap mr10"> -->
<!--                                 <input type="radio" name="empYn" v-model="employee" value="Y" disabled="" /> -->
<!--                                 <i class="radio-icon"></i> -->
<!--                                 <em>{{ $t('FIELD.GLOBAL.YES') }}</em> -->
<!--                             </label> -->
<!--                             <label class="radiobox-wrap"> -->
<!--                                 <input type="radio" name="empYn" v-model="employee" value="N" disabled="" /> -->
<!--                                 <i class="radio-icon"></i> -->
<!--                                 <em>{{ $t('FIELD.GLOBAL.NO') }}</em> -->
<!--                             </label> -->
<!--                         </div> -->
<!--                         <div class="fR w65"> -->
<!--                             <input type="text" class="text_input w100" v-model="loginEmployee" disabled="" /> -->
<!--                         </div> -->
<!--                     </td> -->
                    <th>{{ $t('FIELD.USER.TEAM') }}</th>
                    <td data-input-type="select">
                        <select class="slt_white w100" v-model="teamNo">
                            <option value="" selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
                            <option v-for="code in teamTypes" :key="code.code" :value="code.code">{{
                                code.codeName
                            }}</option>
                        </select>
                    </td>
                </tr>
<!--                  <tr>
                    
                    <th>{{ $t('FIELD.GLOBAL.DEPARTMENT') }}</th>
                    <td v-if="this.deptLevel == ''" data-input-type="select">
		                        <span>&nbsp;</span>
		            </td>
		            <td v-if="this.deptLevel == '1'" data-input-type="select">
		                ASC/CC
		                <select class="slt_white" style= "width:49.2%" v-model="deptRhqCd" @change="changeRhqCd('D')" disabled>
		                    <option value="" selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
		                    <option v-for="code in deptRhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
		                </select>
		                <select class="slt_white" style= "width:49.2%" v-model="deptCorpNo" disabled>
		                    <option value="" selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
		                    <option v-for="code in deptCorpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
		                </select>
		            </td>
		            <td v-if="this.deptLevel == '2'" data-input-type="select">
		                Subsidiary
		                <select class="slt_white" style= "width:49.2%" v-model="deptRhqCd" @change="changeRhqCd('D')" disabled>
		                    <option value="" selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
		                    <option v-for="code in deptRhqCdList" :key="code.code" :value="code.code">{{
		                        code.codeName
		                    }}</option>
		                </select>
		                <select class="slt_white" style= "width:49.2%" v-model="deptCorpNo" disabled>
		                    <option value="" selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
		                    <option v-for="code in deptCorpNoList" :key="code.code" :value="code.code">{{
		                        code.codeName
		                    }}</option>
		                </select>
		            </td>
		            <td v-if="this.deptLevel == '3'" data-input-type="select">
		                RHQ
		                <select class="slt_white w100p" v-model="deptRhqCd" @change="changeRhqCd('D')" disabled>
		                    <option value="" selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
		                    <option v-for="code in deptRhqCdList" :key="code.code" :value="code.code">{{
		                        code.codeName
		                    }}</option>
		                </select>
		            </td>
		            <td v-if="this.deptLevel == '4'" data-input-type="select">
		                GBM
		                <select class="slt_white w100p" v-model="deptCorpNo" disabled>
		                    <option value="" selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option>
		                    <option v-for="code in gbmTypes" :key="code.code" :value="code.code">{{
		                        code.codeDesc
		                    }}</option>
		                </select>
		            </td>
		             <th></th>
                    <td>
                        <span class="clearable">
                        </span>
                    </td>
                </tr> -->
<!--                 <tr> -->
<!--                     <th>{{ $t('FIELD.GLOBAL.DEPOT') }}</th> -->
<!--                     <td data-input-type="select"> -->
<!--                         <select class="slt_white input-58" v-model="depot"> -->
<!--                             <option value="" selected>{{ $t('FIELD.GLOBAL.OPTION.DETAIL.NAME') }}</option> -->
<!--                             <option v-for="code in depotTypes" :key="code.code" :value="code.code">{{ -->
<!--                                 code.codeName -->
<!--                             }}</option> -->
<!--                         </select> -->
<!--                     </td> -->
<!--                     <th v-if="this.sysAdmYn == 'Y'">Restore ID</th> -->
<!--                     <td v-if="this.sysAdmYn == 'Y'" data-input-type="select"> -->
<!--                         <select class="slt_white input-58" v-model="delYn"> -->
<!--                             <option value="">N</option> -->
<!--                         	<option value="N">Y</option> -->
<!--                         </select> -->
<!--                     </td> -->
<!--                 </tr> -->
                <tr>
                    <th>{{ $t('FIELD.USER.ROLE') }}</th>
                    <td colspan="3">
                        <div class="pop_sel_multiple">
                            <select multiple v-model="roleSel">
                                <option v-for="code in authRoles" :key="code.code" :value="code.code">{{
                                    code.desc
                                }}</option>
                            </select>
                        </div>
                        <div class="btn_wrap pt-10">
                            <div class="btn_right">
                                <a href="javascript:" class="btn_sm_white" title @click="roleAdd()">{{
                                    $t('BUTTON.GLOBAL.ADD')
                                }}</a>
                                <a href="javascript:" class="btn_sm_white" title @click="roleRemove()">{{
                                    $t('BUTTON.GLOBAL.REMOVE')
                                }}</a>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>{{ $t('FIELD.GLOBAL.STATUS') }}</th>
                    <td data-input-type="select">
                        <select class="slt_white w100" v-model="loginStatus">
                            <option value="" selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                            <option v-for="code in statTypes" :key="code.code" :value="code.code">{{
                                code.codeDesc
                            }}</option>
                        </select>
                    </td>
                     <th v-if="this.sysAdmYn == 'Y'">Restore ID</th>
		             <td v-if="this.sysAdmYn == 'Y'" data-input-type="select">
		                        <select class="slt_white w100" v-model="delYn">
		                            <option value="">N</option>
		                        	<option value="N">Y</option>
		                        </select>
		             </td>
                </tr>
            </tbody>
        </table>
        <div class="btn_wrap topLine"></div>
        <!-- //detail_Code Manage -->
        <!-- Authority List tit -->
        <div class="sub_tit mt25">{{ $t('SUBTITLE.AUTHREQ.AUTH') }}</div>
        <!-- //Authority List tit -->
        <div class="Authority_wrap">
            <div class="item_Authority">
                <ul class="txt_sel">
                    <li class="tit">{{ $t('FIELD.GLOBAL.MENU') }}</li>
                    <li data-input-type="select" class="w70 fR tR pr20">
                        <select class="slt_white w40p" v-model="menuRhqCd" @change="changeRhqCd('M')">
                            <option value="" selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                            <option v-for="code in menuRhqCdList" :key="code.code" :value="code.code">{{
                                code.codeName
                            }}</option>
                        </select>
                        <select class="slt_white w40p" v-model="menuCorpNo" @change="changeCorpNo()">
                            <option value="" selected>{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                            <option v-for="code in menuCorpNoList" :key="code.code" :value="code.code">{{
                                code.codeName
                            }}</option>
                        </select>
                    </li>
                </ul>
                <dl class="tree_wrap noLine pl10">
                    <dd>
                        <article class="tree_group">
                            <ul class="tree_list">
                                <li v-for="menu1 in menuAllTrees" :key="menu1.MENUID">
                                    <a href="javascript:" class="ico_tree" v-if="menu1.subMenu" @click="treeClick($event, menu1.MENUID)" ><span class="sr_only"></span></a>
                                    <label class="checkbox-wrap">
                                        <input type="checkbox" :name="'menu-' + menu1.MENUPARENTID + '-' + menu1.MENUID" class="chk" :value="menu1.MENUID" 
                                              :disabled="true" :checked="'Y' === menu1.MENUCHECK ? true : false" @change="treeMenuChange($event, menu1.MENUID)"/>
                                        <i class="check-icon"></i>
                                        <em>{{ menu1.MENUNAME }}</em>
                                    </label>
                                    <label class="checkbox-wrap">
                                        (
                                        <input type="checkbox" :name="'read-' + menu1.MENUPARENTID + '-' + menu1.MENUID" class="chk" :value="menu1.MENUID"
                                            :disabled="true" :checked="'Y' === menu1.CREATIONCHECK ? true : false" 
                                            @change="treeReadChange($event, menu1.MENUID)" />
                                        <i class="check-icon"></i><em>{{ $t('FIELD.GLOBAL.CREATION') }}</em> )
                                    </label>

                                    <ul class="tree_sub_list">
                                        <li v-for="menu2 in menu1.subMenu" :key="menu2.MENUID">
                                            <a href="javascript:" class="ico_tree" v-if="menu2.subMenu" @click="treeClick($event, menu2.MENUID)">
                                                <span class="sr_only"></span>
                                            </a>
                                            <label class="checkbox-wrap">
                                                <input type="checkbox" :name=" 'menu-' + menu1.MENUPARENTID + '-' + menu2.MENUPARENTID + '-' + menu2.MENUID"
                                                       class="chk" :value="menu2.MENUID" :checked="'Y' === menu2.MENUCHECK ? true : false"
                                                       :disabled="true" @change="treeMenuChange($event, menu2.MENUID)"/>
                                                <i class="check-icon"></i>
                                                <em>{{ menu2.MENUNAME }}</em>
                                            </label>
                                            <label class="checkbox-wrap">
                                                (
                                                <input type="checkbox" :name=" 'read-' + menu1.MENUPARENTID + '-' + menu2.MENUPARENTID + '-' + menu2.MENUID"
                                                       class="chk" :value="menu2.MENUID" :disabled="true"
                                                       :checked="'Y' === menu2.CREATIONCHECK ? true : false" @change="treeReadChange($event, menu2.MENUID)"
                                                />
                                                <i class="check-icon"></i>
                                                <em>{{ $t('FIELD.GLOBAL.CREATION') }}</em> )
                                            </label>
                                            <ul class="tree_sub_list">
                                                <li v-for="menu3 in menu2.subMenu" :key="menu3.MENUID">
                                                    <a href="javascript:" class="ico_tree" v-if="menu3.subMenu" @click="treeClick($event, menu3.MENUID)">
                                                        <span class="sr_only"></span>
                                                    </a>
                                                    <label class="checkbox-wrap">
                                                        <input type="checkbox" :name=" 'menu-' + menu1.MENUPARENTID + '-' + menu2.MENUPARENTID + '-' +
                                                            menu3.MENUPARENTID + '-' + menu3.MENUID" class="chk" :value="menu3.MENUID"
                                                            :disabled="true"
                                                            :checked="'Y' === menu3.MENUCHECK ? true : false" @change="treeMenuChange($event, menu3.MENUID)"/>
                                                        <i class="check-icon"></i>
                                                        <em>{{ menu3.MENUNAME }}</em>
                                                    </label>
                                                    <label class="checkbox-wrap">
                                                        (
                                                        <input type="checkbox" :name=" 'read-' + menu1.MENUPARENTID + '-' + menu2.MENUPARENTID + '-' +
                                                            menu3.MENUPARENTID + '-' + menu3.MENUID" class="chk" :value="menu3.MENUID" 
                                                            :disabled="true"
                                                            :checked="'Y' === menu3.CREATIONCHECK ? true : false" @change="treeReadChange($event, menu3.MENUID)"/>
                                                        <i class="check-icon"></i>
                                                        <em>{{ $t('FIELD.GLOBAL.CREATION') }}</em> )
                                                    </label>
                                                    <ul class="tree_sub_list">
                                                        <li v-for="menu4 in menu3.subMenu" :key="menu4.MENUID">
                                                            <a href="javascript:" class="ico_tree" v-if="menu4.subMenu" @click="treeClick($event, menu4.MENUID)" >
                                                                <span class="sr_only"></span>
                                                            </a>
                                                            <label class="checkbox-wrap">
                                                                <input type="checkbox" :name=" 'menu-' + menu1.MENUPARENTID + '-' + menu2.MENUPARENTID +
                                                                    '-' + menu3.MENUPARENTID + '-' + menu4.MENUPARENTID + '-' + menu4.MENUID" 
                                                                    class="chk" :value="menu4.MENUID" :checked="'Y' === menu4.MENUCHECK ? true : false"
                                                                    :disabled="true" @change="treeMenuChange($event, menu4.MENUID)"/>
                                                                <i class="check-icon"></i>
                                                                <em>{{ menu4.MENUNAME }}</em>
                                                            </label>
                                                            <label class="checkbox-wrap">
                                                                (
                                                                <input type="checkbox" :name="'read-' + menu1.MENUPARENTID + '-' + menu2.MENUPARENTID +
                                                                    '-' + menu3.MENUPARENTID + '-' + menu4.MENUPARENTID + '-' + menu4.MENUID" class="chk"
                                                                    :disabled="true" :value="menu4.MENUID" :checked="'Y' === menu4.CREATIONCHECK ? true : false" 
                                                                    @change="treeReadChange($event, menu4.MENUID)"/>
                                                                <i class="check-icon"></i>
                                                                <em>{{ $t('FIELD.GLOBAL.CREATION') }}</em> )
                                                            </label>
                                                            <ul class="tree_sub_list">
                                                                <li v-for="menu5 in menu4.subMenu" :key="menu5.MENUID">
                                                                    <a href="javascript:" class="ico_tree" v-if="menu5.subMenu" @click="treeClick($event, menu5.MENUID)">
                                                                        <span class="sr_only"></span>
                                                                    </a>
                                                                    <label class="checkbox-wrap">
                                                                        <input
                                                                            type="checkbox" :name="'menu-' + menu1.MENUPARENTID + '-' + menu2.MENUPARENTID 
                                                                            + '-' + menu3.MENUPARENTID + '-' + menu4.MENUPARENTID + '-' + menu5.MENUPARENTID 
                                                                            + '-' + menu5.MENUID" class="chk" :checked="'Y' === menu5.MENUCHECK ? true : false" 
                                                                            :disabled="true" :value="menu5.MENUID" 
                                                                            @change="treeMenuChange($event, menu5.MENUID)" />
                                                                        <i class="check-icon"></i>
                                                                        <em>{{ menu5.MENUNAME }}</em>
                                                                    </label>
                                                                    <label class="checkbox-wrap">
                                                                        (
                                                                        <input type="checkbox" :name="'read-' + menu1.MENUPARENTID + '-' + menu2.MENUPARENTID 
                                                                            + '-' + menu3.MENUPARENTID + '-' + menu4.MENUPARENTID + '-' + menu5.MENUPARENTID 
                                                                            + '-' + menu5.MENUID" class="chk" :value="menu5.MENUID" 
                                                                            :disabled="true" 
                                                                            :checked="'Y' === menu5.CREATIONCHECK ? true : false" 
                                                                            @change="treeReadChange($event, menu5.MENUID)"/>
                                                                        <i class="check-icon"></i>
                                                                        <em>{{ $t('FIELD.GLOBAL.CREATION') }}</em>
                                                                    </label>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </article>
                    </dd>
                </dl>
            </div>
            <div class="item_Authority">
                <ul class="txt_sel">
                    <li class="tit">{{ $t('FIELD.FAST.ADVANCED.PRODUCTCATEGORY') }}</li>
                    <li class="btn">
                        <a href="javascript:" class="btn_sm_white" title="" @click="cateAdd()">{{
                            $t('BUTTON.GLOBAL.ADD')
                        }}</a>
                        <a href="javascript:" class="btn_sm_white" title="" @click="cateDelete()">{{
                            $t('BUTTON.GLOBAL.DELETE')
                        }}</a>
                    </li>
                </ul>
                <dt>
                    <select multiple v-model="cateSel">
                        <option v-for="code in categories" :key="code.PROD_CD" :value="code.PROD_CD">{{
                            code.PROD_NM
                        }}</option>
                    </select>
                </dt>
            </div>
        </div>
        <!-- page btn -->
        <div class="btn_wrap_full topLine">
            <a href="JavaScript:" class="btn_white" @click="goUserList()" title>{{ $t('BUTTON.GLOBAL.LIST') }}</a>
            <!-- <div class="btn_right" v-if="this.sysAdmYn == 'Y'"> -->
            <div class="btn_right">
                <a href="javascript:" class="btn_blue" title @click="userSave()">{{ $t('BUTTON.GLOBAL.SAVE') }}</a
                ><!-- Create 일때 save버튼 생성-->
            </div>
        </div>
        <!-- //page btn -->
    </div>
    <!-- //Label Setting list -->
    <!-- contents -->
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import axios from 'axios';
import qs from 'query-string';
import _ from 'lodash';
import $ from 'jquery';
//import constants             from '@/constants';
//import SDLLocale             from '@/mixin/SDLLocale';
import constants from '@/constants';
import { SDLUtil, MenuUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import CateAddPopup from '~va/system/userRole/CategoryAddPopup';
import RoleAddPopup from './RoleAddPopup';
import api from '@/service';

export default {
    name: 'UserAdminDetail',
    props: {
        pLoginNo: { type: String, default: '' },
    },
    data() {
        return {
            isLoading: true,
            viewMode: false, // 'create or modify'
            userNo: this.pLoginNo,
            loginId: '',
            loginName: '',
            email: '',
            phoneNo: '',
            mobileNo: '',
            loginEmployee: '',
            employee: '',
            teamNo: '',
            deptLevel: '',
            department: '',
            depot: '',
            delYn: '',
            loginStatus: '',
            loginCorpNo: '',
            deptRhqCd: '',
            menuRhqCd: '',
            deptCorpNo: '',
            menuCorpNo: '',
            sysAdmYn: '',
            //            gbmCd: '',
            deptRhqCdList: [],
            menuRhqCdList: [],
            deptCorpNoList: [],
            menuCorpNoList: [],
            roleSel: [],
            cateSel: [],
            authRoles: [], // Role box에서 보이는 목록
            menuAllTrees: [], // Menu box에서 보이는 목록
            categories: [], // Product Category 탭에서 보이는 목록
            levelTypes: [], // Level comboBox
            depotTypes: [], // Depot comboBox
            statTypes: [], // Stat comboBox
            teamTypes: [], // Team comboBox
            gbmTypes: [], // GBM comboBox
            //            roleTypes:  [],
            authUsers: [], // User 탭에서 보이는 목록
            //            deleteItems: []  // 체크된 삭제 목록
        };
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
            userRoles: 'getRoles',
        }),
        getLoginNo() {
            return this.loginNo || '';
        },
        getUserRole() {
            return this.userRoles || [];
        },
    },
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
    },
    methods: {
        loadSubsiDeptCodes(depth, pCode, defCd) {
            if (depth == 1) {
                // RhqCd
                this.getCodeComboList(this.getLoginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                    this.deptRhqCdList = data;
                    this.deptRhqCd = pCode;
                    if (pCode) this.loadSubsiDeptCodes(2, this.deptRhqCd, this.deptCorpNo);
                });
            } else if (depth == 2) {
                // CorpNo
                this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                    this.deptCorpNoList = data;
                    if (defCd) this.deptCorpNo = defCd;
                    else this.deptCorpNo = data[0].code;
                });
            }
        },
        // 메뉴를 위한 Subsidiary
        loadSubsiMenuCodes(depth, pCode, defCd) {
            if (depth == 1) {
                // RhqCd
                this.getCodeComboList(this.getLoginNo, 'RHQ_AUTH_ACCESS_CD').then(data => {
                    this.menuRhqCdList = data;
                    this.menuRhqCd = pCode;
                    this.loadSubsiMenuCodes(2, this.menuRhqCd, this.deptCorpNo);
                });
            } else if (depth == 2) {
                // CorpNo
                if (pCode) {
                    this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                        this.menuCorpNoList = data;
                        if (defCd) this.menuCorpNo = defCd;
                        else this.menuCorpNo = '';
                    });
                } else {
                    this.menuCorpNo = '';
                }
            }
        },
        loadCommonCodes() {
            let param = {};
            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/user/userMngComCodes.skp`, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.statTypes = resp.data.statTypes;
                    this.teamTypes = resp.data.teamTypes;
                    this.gbmTypes  = resp.data.gbmTypes;
                    //                this.roleTypes = resp.data.roleTypes;
                })
                .catch(err => {
                    console.log('Error occured : ', err);
                });
        },
        initDataLoad() {
            const param = { loginNo: this.pLoginNo };
            return axios
                .get(`${SDLUtil.API_URL}/basis/admin/user/userAdminInfo.skp`, { params: param })
                .then(resp => {
                    if (resp.data.resNo == 2) {
                        SDLUtil.showLoadingBar(false);
                        SDLUtil.alert({
                            msg: 'TITLE.PERSONALIZE.AUTH.REQUEST',
                            onOkEvt: () => {
                                this.goUserList();
                            }
                        });
                        return;
                    }
                    let userInfo = resp.data.result;
                    this.loginId = userInfo.loginId;
                    this.loginName = userInfo.loginName;
                    this.email = userInfo.email;
                    this.phoneNo = userInfo.phoneNo;
                    this.mobileNo = userInfo.mobileNo;
                    this.loginEmployee = userInfo.loginEmployee;
                    this.employee = userInfo.loginEmployee ? 'Y' : 'N';
                    this.teamNo = userInfo.teamNo ? userInfo.teamNo : '';
                    this.depot = userInfo.depotLocCd;
                    this.deptLevel = userInfo.deptLevelCd;
                    this.loginStatus = userInfo.loginStatus;
                    this.loginCorpNo = userInfo.loginCorp;
                    this.deptRhqCd = userInfo.deptRhqNo;
                    this.deptCorpNo = userInfo.deptNo;
                    //this.delYn = userInfo.delYn;
//                    console.log('this.deptCorpNo ==> ', this.deptCorpNo);
                    //                    this.gbmCd = userInfo.deptNo;
                    this.menuRhqCd  = userInfo.deptRhqNo;
                    this.menuCorpNo = userInfo.loginCorp;

                    this.loadSubsiDeptCodes(1, this.deptRhqCd); // Subsidiary of Department
                    this.loadSubsiMenuCodes(1, this.menuRhqCd); // Subsidiary of Menu

                    // authRoles
                    this.appendRolesToBox(resp.data.resultRoles.rowData);

                    // Categories
                    this.appendCatesToBox(resp.data.resultPrdCate.rowData);

                    // Menu List
                    this.loadMenuList(this.authRoles);

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                });
        },
        changeCorpNo() {
            this.loadMenuList(this.authRoles);
        },
        loadMenuList(resultRoles) {
            let authCorps = [];
            this.menuAllTrees = [];
            resultRoles.forEach(elm => {
                let pre = elm.code.split('^');
                authCorps.push(pre[1]); // 메뉴 로드시 IN 조건에 필요
                
            });
//            if (!this.menuCorpNo) this.menuCorpNo = 'C100';
            const param = { loginNo: this.userNo, menuCorpNo: this.menuCorpNo || 'C100', authCorpId: authCorps };

            return axios
                .post(`${SDLUtil.API_URL}/basis/admin/user/userAdminMenuList.skp`, qs.stringify(param), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    let menuTree1 = [];
                    let menuTree2 = [];
                    let menuTree3 = [];
                    let menuTree4 = [];
                    let menuTree5 = [];

                    for (const menu of resp.data.rowData) {
                        if (1 === menu.MENULEVEL) {
                            menuTree1.push(menu);
                        } else if (2 === menu.MENULEVEL) {
                            menuTree2.push(menu);
                        } else if (3 === menu.MENULEVEL) {
                            menuTree3.push(menu);
                        } else if (4 === menu.MENULEVEL) {
                            menuTree4.push(menu);
                        } else if (5 === menu.MENULEVEL) {
                            menuTree5.push(menu);
                        }
                    }

                    menuTree4 = this.menuTreeMerge(menuTree4, menuTree5);
                    menuTree3 = this.menuTreeMerge(menuTree3, menuTree4);
                    menuTree2 = this.menuTreeMerge(menuTree2, menuTree3);
                    menuTree1 = this.menuTreeMerge(menuTree1, menuTree2);

                    this.menuAllTrees = menuTree1;
                })
                .catch(err => {
                    Vue.$log.error(err);
                });
        },
        menuTreeMerge(parent, cildren) {
            for (const menus of parent) {
                const addMenu = new Array();
                for (const subMenu of cildren) {
                    if (subMenu.MENUPARENTID === menus.MENUID) {
                        addMenu.push(subMenu);
                    }
                }
                if (0 < addMenu.length) {
                    menus.subMenu = addMenu;
                }
            }
            return parent;
        },
        treeClick(e) {
            if (
                $(e.target)
                    .closest('li')
                    .hasClass('active') == true
            ) {
                $(e.target)
                    .closest('li')
                    .removeClass('active');
            } else {
                // $('.tree_list > li').removeClass('active');
                $(e.target)
                    .closest('li')
                    .addClass('active');
            }
        },
        treeMenuChange(e, v) {
            return;

            let name = $(e.target).prop('name');
            let parentNames = $(e.target)
                .prop('name')
                .split('-');
            if ($(e.target).is(':checked')) {
                $('input[name*=' + name + ']').each(function(idx) {
                    $(this).prop('checked', true);
                });

                let parentName = '';
                parentNames.forEach(target => {
                    if (!SDLUtil.isNull(parentName)) {
                        parentName += '-';
                    }
                    parentName += target;
                    $('input[name=' + parentName + ']').prop('checked', true);
                });

                name = name.replace('menu-', 'read-');
                $('input[name*=' + name + ']').each(function(idx) {
                    $(this).prop('disabled', false);
                });

                parentName = '';
                parentNames.forEach(target => {
                    if (!SDLUtil.isNull(parentName)) {
                        parentName += '-';
                    }
                    parentName += target.replace('menu-', 'read-');
                    $('input[name=' + parentName + ']').prop('disabled', false);
                });
            } else {
                $('input[name*=' + name + ']').each(function(idx) {
                    $(this).prop('checked', false);
                });

                for (let i = parentNames.length; 0 < i; i--) {
                    let parentName = '';
                    let cnt = 0;

                    for (let index = 0; index < i; index++) {
                        parentName += parentNames[index] + '-';
                    }

                    $('input[name*=' + parentName + ']').each(function(idx) {
                        if ($(this).is(':checked')) {
                            cnt++;
                        }
                    });

                    if (0 === cnt) {
                        $('input[name=' + parentName.substring(0, parentName.length - 1) + ']').prop('checked', false);
                        $(
                            'input[name=' +
                                parentName.replace('menu-', 'read-').substring(0, parentName.length - 1) +
                                ']',
                        ).prop('checked', false);
                    }
                }

                name = name.replace('menu-', 'read-');
                $('input[name*=' + name + ']').each(function(idx) {
                    $(this).prop('checked', false);
                    $(this).prop('disabled', true);
                });
            }
        },
        treeReadChange(e, v) {
            let name = $(e.target).prop('name');
            let parentNames = $(e.target)
                .prop('name')
                .split('-');
            if ($(e.target).is(':checked')) {
                $('input[name*=' + name + ']').each(function(idx) {
                    if (!$(this).is(':disabled')) {
                        $(this).prop('checked', true);
                    }
                });

                let parentName = '';
                parentNames.forEach(target => {
                    if (!SDLUtil.isNull(parentName)) {
                        parentName += '-';
                    }
                    parentName += target;
                    $('input[name=' + parentName + ']').prop('checked', true);
                });
            } else {
                $('input[name*=' + name + ']').each(function(idx) {
                    $(this).prop('checked', false);
                });

                for (let i = parentNames.length; 0 < i; i--) {
                    let parentName = '';
                    let cnt = 0;

                    for (let index = 0; index < i; index++) {
                        parentName += parentNames[index] + '-';
                    }

                    $('input[name*=' + parentName + ']').each(function(idx) {
                        if ($(this).is(':checked')) {
                            cnt++;
                        }
                    });

                    if (0 === cnt) {
                        $('input[name=' + parentName.substring(0, parentName.length - 1) + ']').prop('checked', false);
                    }
                }
            }
        },
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        // Role에 추가..
        appendRolesToBox(roles) {
            let ncnt = 0;
            roles.forEach(elm => {
                let desc = '[' + elm.AUTH_ID + ']' + ' ' + elm.AUTH_NM + ' (' + elm.CORP_NM + ')';
                let role = { code: elm.AUTH_ID + '^' + elm.AUTH_CORP_ID, desc: desc };
                if (!SDLUtil.existArrays(this.authRoles, 'code', role.code)) {
                    // 없을 때만 추가..
                    this.authRoles.push(role);
                }
                ncnt++;
            });
        },
        // Product Category에 추가..
        appendCatesToBox(cates) {
            cates.forEach(elm => {
                let key = elm.PROD_CD;
                if (!SDLUtil.existArrays(this.categories, 'PROD_CD', key)) {
                    // 없을 때만 추가..
                    this.categories.push(elm);
                }
            });
        },
        changeRhqCd(mode) {
            if (mode == 'D') {
                // Department
                if (this.deptRhqCd == '') {
                    this.deptCorpNoList = [];
                    this.deptCorpNo = '';
                } else {
                    this.loadSubsiDeptCodes(2, this.deptRhqCd);
                }
            } else if (mode == 'M') {
                // Menu
                if (this.menuRhqCd == '') {
                    this.menuCorpNoList = [];
                    this.menuCorpNo = '';
                } else {
                    this.loadSubsiMenuCodes(2, this.menuRhqCd);
                }
            }
        },
        // 이 코드에 따라 Department ELement가 변경됨.
        changeLevel() {
            if (this.deptLevel == '1') {
                // ACC/CC
            } else if (this.deptLevel == '2') {
                // Subsidiary
            } else if (this.deptLevel == '3') {
                // RHQ
                this.deptRhqCd = '';
            } else if (this.deptLevel == '4') {
                // GBM
                this.deptCorpNo = '';
            } else {
                // Not selected
            }
        },
        // 저장
        saveExec(url, formData, msg) {
            SDLUtil.showLoadingBar(true);
            return axios
                .post(url, qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then(resp => {
                    console.log('Save.resp ==> ', resp);
                    SDLUtil.showLoadingBar(false);
                    if (resp.data.result == 1) {
                        this.viewMode = true;
                        Vue.toasted.show(
                            SDLUtil.getMsgProp(msg), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                        this.delYn = '';
                        this.initDataLoad();
                    } else if (resp.data.result == 2) {
                        SDLUtil.alert('TITLE.PERSONALIZE.AUTH.REQUEST');
                    } else if (resp.data.result == 0) {
                        SDLUtil.alert('Admin users cannot be modified.');
                    } else {
                        SDLUtil.alert('Error occured ' + resp.data.result);
                    }
                })
                .catch(err => {
                    this.searchStatus = 'error';
                    SDLUtil.showLoadingBar(false);
                });
        },
        roleAdd() {
            SDLUtil.showLoadingBar(true);
            SDLUtil.show(
                RoleAddPopup,
                {
                    title: 'Select Role',
                    pRhqCdList: this.deptRhqCdList,
                    rtnRoleFunc: authRole => {
                        this.appendRolesToBox(authRole);
                        this.loadMenuList(this.authRoles);
                    },
                }, // component params
                {
                    height: 'auto',
                }, // dialog params
            );
            SDLUtil.showLoadingBar(false);
        },
        roleRemove() {
            if (this.roleSel.length < 1) {
                SDLUtil.alert('FIELD.GLOBAL.OPTION.DETAIL.NAME');
                return;
            }
            let newList = [];
            this.authRoles.forEach(elm => {
                if (!this.roleSel.includes(elm.code)) newList.push(elm);
            });
            this.authRoles = newList;
            this.cateSel = [];

            this.loadMenuList(this.authRoles);
        },
        cateAdd() {
            SDLUtil.showLoadingBar(true);
            SDLUtil.show(
                CateAddPopup,
                {
                    title: 'Product Category Search',
                    isConfirm: false,
                    rtnFunc: cates => {
                        this.appendCatesToBox(cates);
                    },
                }, // component params
                {
                    height: 'auto',
                }, // dialog params
            );
            SDLUtil.showLoadingBar(false);
        },
        cateDelete() {
            if (this.cateSel.length < 1) {
                SDLUtil.alert('FIELD.GLOBAL.OPTION.DETAIL.NAME');
                return;
            }
            let newList = [];
            this.categories.forEach(elm => {
                let exist = this.cateSel.indexOf(elm.PROD_CD);
                if (exist < 0) newList.push(elm);
            });
            this.categories = newList;
            this.cateSel = [];
        },
        userValidateion() {
            let bRes = true;
            let valids = [this.teamNo, /* this.deptLevel, this.depot,*/  this.loginStatus];
            let titles = ['Team', /*'Level', 'Depot',*/ 'Status'];
/*            
            let index = 1;
            if (this.deptLevel == '2' || this.deptLevel == '3') {
                valids.push(this.deptRhqCd);
                titles.push('Department' + index);
                index++;
            }
            if (this.deptLevel == '2' || this.deptLevel == '4') {
                valids.push(this.deptCorpNo);
                titles.push('Department' + index);
            }
*/            
            $.each(valids, function(idx, elm) {
                if (!elm) {
                    bRes = false;
                    SDLUtil.alert('Empty value of [' + titles[idx] + ']');
                    return;
                }
            });
            return bRes;
        },
        saveParams(exclude = []) {
            // Role 코드들
            let roleCodes = [];
            this.authRoles.forEach(elm => {
                let pre = elm.code.split('^');
                if(pre[1] != "undefined") {
                	roleCodes.push(pre[1]);
                }
            });

            // 카테고리 코드들
            let cateCodes = [];
            this.categories.forEach(elm => {
                cateCodes.push(elm.PROD_CD);
            });

            let saveParams = {
                loginNo: this.userNo,
                loginId: this.loginId,
                loginName: this.loginName,
                loginCorp: this.loginCorpNo,
                loginStatus: this.loginStatus,
                teamNo: this.teamNo,
                deptNo: this.deptCorpNo,
                deptLevelCd: this.deptLevel,
                depotLocCd: this.depot,
                deptRhqCd: this.deptRhqCd,
                deptCorpNo: this.deptCorpNo,
                authCorpId: roleCodes,
                productCategory: cateCodes
            };
            if('Y' == this.sysAdmYn) {
            	saveParams.delYn = this.delYn;
            	if('N' == this.delYn) {
            		saveParams.loginStatus = 'A';	
            	}
            }
            return saveParams;
        },
        // 메인(전체) 저장
        userSave() {
            if (!this.userValidateion()) {
                return;
            }

            const param = this.saveParams();
            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.SAVE',
                onOkEvt: () => {
                    let url = `${SDLUtil.API_URL}/basis/admin/user/userAdminSave.skp`;
                    this.saveExec(url, param, 'MESSAGE.SUCCESS.SAVED'); // 실행 후 아무것도 하지 않음.
                },
            });
        },
        goUserList() {
            EventBus.$emit('goUserList', 1);
        },
    }, // methods
    created() {},
    mounted() {
        SDLUtil.showLoadingBar(true);

        // Level
        api.getCommonCodeList('DEPT_LEVEL_CD').then(res => {
            this.levelTypes = res;
        });
        // Depot
        api.getCommonCodeList('DEPOT_LOC_CD').then(res => {
            this.depotTypes = res;
        });

        this.loadCommonCodes(); // 공통코드
        this.initDataLoad(); // 메인 데이터
        // console.log(this.userRoles, 'o%');
        if(this.getUserRole.includes(`${constants.SYSTEM_ADMIN}`)) {
        	this.sysAdmYn = 'Y';
        } else {
        	this.sysAdmYn = '';        	
        }
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        //        EventBus.$off('refresh');
        //        EventBus.$off('goList');
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/user/UserAdminView.vue